import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrIconButton } from "../buttons";
import { GrIcon } from "../icons";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import classNames from "classnames";
import { useLayoutEffect, useState } from "react";
export function GrCollapsePopover(props) {
    var _a;
    const [open, setOpen] = useState(props.open);
    useLayoutEffect(() => {
        var _a;
        setOpen((_a = props.open) !== null && _a !== void 0 ? _a : false);
    }, [props.open]);
    const positionProps = getPositionProps(props);
    return (_jsxs(StyledGrCollapsePopover, { className: classNames("GrCollapsePopover", props.className), position: (_a = props.position) !== null && _a !== void 0 ? _a : "relative", ...positionProps, children: [open && props.children, _jsxs(StyledHeader, { justifyContent: "space-between", alignItems: "center", children: [_jsx("div", { children: props.title }), _jsxs(GrStack, { alignContent: "center", height: "32px", alignItems: "center", children: [_jsx(GrIconButton, { iconType: open ? "chevron-down" : "chevron-up", style: { height: 16 }, size: 16, onClick: () => setOpen(prev => !prev) }), props.secondaryAction] })] })] }));
}
export function GrCollapsePopoverList(props) {
    return _jsx(StyledList, { className: classNames("GrCollapsePopover-list", props.className), children: props.children });
}
export function GrCollapsePopoverListItem(props) {
    return (_jsxs(StyledListItem, { className: classNames("GrCollapsePopover-list-item", props.className), secondaryAction: props.secondaryAction, children: [props.icon && (_jsx(ListItemIcon, { children: _jsx(GrIcon, { type: props.icon.name, color: props.icon.color, size: 20 }) })), _jsx(ListItemText, { primary: props.text, primaryTypographyProps: {
                    style: {
                        ...typography["Content.Body04"],
                        color: palette.grey090,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "280px",
                    },
                } })] }));
}
export function getPositionProps(props) {
    return props.position === "fixed" ? { top: props.top, left: props.left, right: props.right, bottom: props.bottom } : {};
}
const StyledGrCollapsePopover = styled.div `
  position: ${({ position }) => position !== null && position !== void 0 ? position : "relative"};
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  bottom: ${({ bottom }) => bottom};

  ${({ position }) => (position === "fixed" ? "z-index: 1100;" : "")}
`;
const LIST_ITEM_HEIGHT = "48px";
// NOTE: 아래는 임시로 추가된 코드입니다.
const StyledListItem = styled(ListItem) `
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  height: ${LIST_ITEM_HEIGHT};
  gap: 10px;

  .MuiListItemIcon-root {
    min-width: unset;
    padding: 1px;
  }

  &:hover {
    background-color: ${palette.bg020};
  }
`;
const StyledList = styled(List) `
  box-sizing: border-box;
  width: 400px;
  padding: 4px;
  border: 1px solid ${palette.grey020};
  box-shadow: 0px 4px 20px 0px ${palette.black}33;
  position: absolute;
  bottom: calc(100% + 8px);
  border-radius: 6px;
  max-height: calc(${LIST_ITEM_HEIGHT} * 5);
  overflow-y: auto;
  background-color: ${palette.white};

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${palette.grey020};
    border-radius: 8px;
    background-clip: padding-box;
    border: 2px solid transparent;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  z-index: 1100;
`;
const StyledHeader = styled(GrStack) `
  box-sizing: border-box;
  width: 400px;
  height: 32px;
  padding: 6px 16px;
  border-radius: 6px;
  background-color: ${palette.white};
  box-shadow: 0px 0px 16px 0px ${palette.black}1a;

  & button:last-child {
    padding: 0;
  }
`;
//# sourceMappingURL=GrCollapsePopover.js.map